import { VueConstructor } from 'vue'
import moment from 'moment'
import 'moment/locale/es'

moment.locale('es')

export default function install (Vue: VueConstructor, options = {}): void {
  Vue.filter('toCurrency', (value: number|string): string => {
    if (typeof value !== 'number') {
      return value
    }

    const formatter = new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    })

    return formatter.format(value)
  })

  Vue.filter('timeago', (time: string): string => {
    return moment(time).fromNow()
  })
}
